/**
 * Pure helper functions for PostMessage bridge validation.
 * Extracted from use-post-message-bridge.ts for testability.
 */

/** Extracts the origin (scheme + host + port) from a full URL. */
export function originFromUrl(url: string): string {
  try {
    const parsed = new URL(url);
    return parsed.origin;
  } catch {
    return '';
  }
}

/** Inbound message shape from micro-frontends. */
export interface InboundMessage {
  type: 'MODULE_READY';
  version: '1.0';
}

/** Checks whether a value conforms to the InboundMessage schema. */
export function isInboundMessage(data: unknown): data is InboundMessage {
  return (
    typeof data === 'object' &&
    data !== null &&
    'type' in data &&
    (data as InboundMessage).type === 'MODULE_READY' &&
    'version' in data &&
    (data as InboundMessage).version === '1.0'
  );
}

/**
 * Validates whether a message event origin matches a registered module origin.
 * Returns true if the event origin matches, false otherwise.
 */
export function isOriginRegistered(
  eventOrigin: string,
  registeredSourceUrl: string,
): boolean {
  const registeredOrigin = originFromUrl(registeredSourceUrl);
  if (!registeredOrigin) return false;
  return eventOrigin === registeredOrigin;
}
